import script from "./BaseCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseCard.vue?vue&type=script&lang=ts&setup=true"

import "./BaseCard.vue?vue&type=style&index=0&id=fdc11812&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.27_typescript@5.3.3__webpack@5.91.0_webpack-cli@5.1.4_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdc11812"]])

export default __exports__